import { SET_ITEMS } from '../mutation-types'
import axios from 'axios'
import findIndex from 'lodash/findIndex'

const DELETE_ITEM = 'DELETE_ITEM'
const SET_MORE_ITEMS = 'SET_MORE_ITEMS'

export default {
    namespaced: true,

    state: {
        data: [],
        meta: null
    },

    getters: {
        //
    },

    mutations: {
        [SET_ITEMS](state, { data, meta }) {
            state.data = data
            state.meta = meta
        },

        [DELETE_ITEM](state, vmId) {
            const index = findIndex(state.data, vm => vm.id === vmId)
            state.data.splice(index, 1)
        },

        [SET_MORE_ITEMS](state, { data, meta }) {
            state.data.push(...data)
            state.meta = meta
        }
    },

    actions: {
        async fetchAll({ commit }, params) {
            //

            try {
                let response = await axios.get('api/vms', { params })
                commit(SET_ITEMS, response.data)
            } catch (error) {
                return false
            }

            return true
        },

        async delete({ commit }, vmId) {
            try {
                await axios.delete(`api/vms/${vmId}`)

                commit(DELETE_ITEM, vmId)
            } catch (error) {
                return false
            }

            return true
        },

        async loadMore({ state, commit }, { params }) {
            let page = 1
            let last_page = 2

            if (state.meta) {
                page = state.meta.current_page + 1
                last_page = state.meta.last_page
            }

            if (page > last_page) {
                return
            }

            try {
                const response = await axios.get('api/vms', { params: { ...params, page } })
                const { data, meta } = response.data

                commit(SET_MORE_ITEMS, { data, meta })

                return meta.last_page > meta.current_page
            } catch (error) {
                return false
            }
        },
    }
}
